module.exports = __webpack_public_path__ + "static/delivery/img/dw_plan.f4ee2a40.png";